import {  Box, Flex, Stack, Text } from "@mantine/core";
import Header from "./idea-module/Header";
import Body from "./body/Body";
import SideBar from "./right-bar/evidence-card/SideBar";
import "../../css/fontsDesign.css";
import { useContext, useEffect, useState } from "react";
import IdeaContext from "./IdeaContext";
import "./idea.css";
import AddEvidenceScreen from "./right-bar/add-evidence/AddEvidenceScreen";
import { getDuplicateIdea, getIdeaActivityLogs, saveIdea, searchEvidences } from "../../Api";
import { useAuth0 } from "@auth0/auth0-react";
import { stripHtml, useThrottle } from "../../utils";
import OverView from "./idea-module/OverView";
import { useElementSize } from "@mantine/hooks";
import DescriptionWidthMeasurment from "./DescriptionWidthMeasurment";
import TitleWidthMeasurment from "./TitleWidthMeasurment";
import MiniSearch from "minisearch";
import FiltersContext from "../ideas/filters/context/FiltersContext";
import { sortRequests } from "./helpers/sortRequests";
import Impact from "./impact";
import posthog from "posthog-js";
import TrendGraph from "./right-bar/trend-graph";
import { findFilterByName } from "../../context/helpers";
import Split from "react-split";
import { BgColorRouteContext } from "../../context/BgColorContext";
import { IdeaHistoryView } from "./IdeaHistoryView";
import EnhancedBusinessSources from "./right-bar/perspective/EnhancedBusinessSources";
import { usePerspectives } from "../../hooks/useCustomizations";
import {useIdeaFilters} from "../../hooks/useIdeaFilters";

export const parseQueryParams = (search: string) => {
  return new URLSearchParams(search);
};

export const FiltersKeyValMap: any = {
  "Business Name": {
    filter: "businessName",
    perspectiveDataType: "businessName",
    frontendFilter: "businessName",
  },
  "Account.tier": {
    filter: "tier",
    perspectiveDataType: "tier",
    frontendFilter: "company.tier",
  },
  "Account.plan": {
    filter: "plan",
    perspectiveDataType: "plan",
    frontendFilter: "company.plan",
  },
  "Account.accountTypesMap": {
    filter: "accountType",
    perspectiveDataType: "type",
    frontendFilter: "company.type",
  },
  "Company": {
    filter: "Company",
    perspectiveDataType: "Company",
    frontendFilter: "company._id",
  },
  "Quarter": {
    filter: "quarter",
    perspectiveDataType: "quarter",
    frontendFilter: "quarter",
  },
  "Week": {
    filter: "week",
    perspectiveDataType: "week",
    frontendFilter: "week",
  },
};

export const findKeyByPerspectiveDataType = (
  dataType: string
): any | undefined => {
  for (const key in FiltersKeyValMap) {
    if (FiltersKeyValMap[key].perspectiveDataType === dataType) {
      return { key, ...FiltersKeyValMap[key] };
    }
  }
  return dataType;
};

// Helper function to safely get nested properties
export const getNestedProperty = (object: any, path: any) => {
  return path
    .split(".")
    .reduce(
      (obj: any, key: any) =>
        obj && obj[key] !== undefined ? obj[key] : undefined,
      object
    );
};



// Helper function to check if an evidence (request or child) matches a single filter
const evidenceMatchesFilter = (evidence: any, filter: any, ideasFiltersConfig: any): boolean => {
  const { name, type, operator } = filter;
  
  const CurrentFilterConfig = findFilterByName(name, 'evidence', ideasFiltersConfig);
  console.log({CurrentFilterConfig});

  const filterPath = CurrentFilterConfig?.dbFieldPath;
  console.log({filterPath});

  if (!filterPath) return true; // Skip this filter if path is not defined

  const evidenceValue = getNestedProperty(evidence, filterPath);
  console.log('evidenceValue:', evidenceValue, 'for path:', filterPath);

  // Handle boolean type filters differently
  if (type === 'boolean' || CurrentFilterConfig?.type === 'boolean') {
    console.log('Boolean filter:', { filter, evidenceValue });
    
    // Get the operations array
    const operations = filter.operations || [];
    
    // If operator is provided, use it directly
    if (filter.operator !== undefined) {
      // If operator is an array (like [false, null]), check if evidenceValue is in that array
      if (Array.isArray(filter.operator)) {
        const result = filter.operator.includes(evidenceValue);
        console.log('Array operator comparison result:', result);
        return result;
      }
      // Otherwise, direct comparison for single values
      const result = evidenceValue === filter.operator;
      console.log('Direct operator comparison result:', result);
      return result;
    }
    
    // Fallback to using operations array with query if no operator
    const selectedOperation = operations[filter.query];
    if (!selectedOperation) {
      console.log('No selected operation found');
      return true;
    }
    
    console.log('Selected operation:', selectedOperation);
    
    // If the operation value is an array (like [false, null]), check if evidenceValue is in that array
    if (Array.isArray(selectedOperation.value)) {
      const result = selectedOperation.value.includes(evidenceValue);
      console.log('Array operation comparison result:', result);
      return result;
    }
    
    // Otherwise, direct comparison for single values
    const result = evidenceValue === selectedOperation.value;
    console.log('Direct operation comparison result:', result);
    return result;
  }

  // Handle date type filters (matching backend logic)
  if (type === 'date' || CurrentFilterConfig?.type === 'date') {
    console.log('Date filter:', { filter, evidenceValue });
    
    if (!evidenceValue) {
      console.log('No evidence value for date filter');
      return false;
    }

    // Handle date range filtering using selected array (matching backend applyDateFilter)
    if (filter.selected && filter.selected.length === 2) {
      const [startDate, endDate] = filter.selected;
      const start = new Date(startDate);
      const end = new Date(endDate);
      const evidenceDate = new Date(evidenceValue);
      
      // Use same logic as backend: $gte and $lte
      const result = evidenceDate >= start && evidenceDate <= end;
      console.log('Date range filtering result:', result, { evidenceValue, startDate, endDate });
      return result;
    }

    // If no selected dates, warn and include all (matching backend behavior)
    console.warn(`Invalid 'selected' dates for date filter '${filter.name}'.`);
    return true;
  }

  // For non-boolean filters
  if (!filter.selected || filter.selected.length === 0) return true;

  // Original string-based filtering logic for non-boolean filters
  if (Array.isArray(evidenceValue)) {
    return evidenceValue
      .map((eV) => eV.toLowerCase())
      .some((e) => filter.selected.includes(e.toLowerCase()));
  } else {
    return filter.selected.includes(evidenceValue?.toLowerCase());
  }
};

export const filterRequests = (requests: any[], filters: any[], ideasFiltersConfig: any) => {

  // Check if filters are present and if any filter has selected items
  if (!filters.length) {
    return requests; // Return all requests if no filters
  }

  console.log({requests})

  return requests.filter((request) => {
    return filters.every((filter) => {
      // Check if the request itself matches the filter
      const requestMatches = evidenceMatchesFilter(request, filter, ideasFiltersConfig);
      
      // If request matches, return true
      if (requestMatches) {
        return true;
      }

      // If request doesn't match, check if any childEvidence matches
      if (request?.childEvidences && Array.isArray(request.childEvidences) && request.childEvidences.length > 0) {
        const anyChildMatches = request.childEvidences.some((child: any) => 
          evidenceMatchesFilter(child, filter, ideasFiltersConfig)
        );
        
        // Return true if any child matches, otherwise false
        return anyChildMatches;
      }

      // If no children or no child matches, return false
      return false;
    });
  });
};

const NewIdeaView = () => {
  const auth0 = useAuth0();
  const queryParams = parseQueryParams(location.search);
  const requestId = queryParams.get("requestId");

  const { ref: ref1, width: titleWidth } = useElementSize();
  const { ref: ref2, width: descWidth } = useElementSize();
  const {
    idea,
    allRequests: allRequestsContext,
    matches,
    displayedRequests,
    setDisplayedRequests,
    loadingEvidence,
    addEvidenceFormScreen,
    setAddEvidenceFormScreen,
    cardView,
    ideaHistoryView,
    setCardView,
    chosenEvidence,
    setChosenEvidence,
    setDisplayedMatches,
    displayedMatches,
    activeSort,
    ideaId,
    setMatchesTrigger,
    requestsMatches,
    setDisplayedRequestsMatches,
    setRequestsTrend,
    setMatchesTrend,
    setRequestsMatchesTrend,
    type,
    setIdeaHistoryView,
    strongMatches,
    strongRequestsMatches,
    setDisplayedStrongMatches,
    setDisplayedStrongRequestsMatches,
    setIdea
  
  } = useContext(IdeaContext);
  const [filters, setFilters] = useState<any>(() => {
    const queryParams = new URLSearchParams(location.search);
    const filtersStr = queryParams.get("filters");
    return filtersStr ? JSON.parse(decodeURIComponent(filtersStr)) : null;
  });
  

  const { activeFilters } = useContext(FiltersContext);
  const { ideasFiltersConfig } = useIdeaFilters();
  
  // Get perspectives using React Query hook
  const { data: currentPerspectives } = usePerspectives();
  const perspectiveConfigurations = currentPerspectives?.data || [];
  
  const [activeSortOrFilter, setActiveSortOrFilter] = useState(false);
  const [index, setIndex] = useState<string | null>(null);
  const [reviewMode, setReviewMode] = useState(false);
  const [isDescendingSort, setIsDescendingSort] = useState(true);
  const [activeSearch, setActiveSearch] = useState(false);
  const [searchedEvidence, setSearchedEvidence] = useState<any[]>([]);
  const [textItemsResults, setTextItemsResults] = useState([]);
  const [loadingtextItems, setLoadingtextItems] = useState(false);
  const [query, setQuery] = useState("");
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [title, setTitle] = useState(idea?.title);
  const [description, setDescription] = useState(idea?.description);
  const [isLongDescription, setIsLongDescription] = useState(false);
  const [isLongTitle, setIsLongTitle] = useState(false);
  const { setBgColor, setPageName  } = useContext(BgColorRouteContext);
  const [allRequests, setAllRequests] = useState<any[]>([]);
  const [activityLogs, setActivityLogs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [duplicateIdea, setDuplicateIdea] = useState<any>(null);
  const [duplicateIdeaModalOpened, setDuplicateIdeaModalOpened] = useState(false);
  useEffect(() => {
    setBgColor("#F8F8FB");
    setPageName("ideaView"); 
  }, [setBgColor, setPageName]);


  const miniSearch = new MiniSearch({
    fields: ["title", "text", "title1", "text1", "excerpts"],

    searchOptions: {
      fuzzy: 0.2,
      prefix: true,
      combineWith: "AND"
    },
  });
  miniSearch.removeAll();

  useEffect(() => {
    const allRequests = [...allRequestsContext, ...matches, ...requestsMatches];
    setAllRequests(allRequests);
  },[allRequestsContext, matches, requestsMatches])
  
  const dedupedRequests = allRequests.filter((item, index, self) =>
    index === self.findIndex(t => t?._id === item?._id)
  );
  
  const aligned = dedupedRequests?.map((m: any) => {
    // Extract excerpts text if it exists
    let excerptsText = '';
    if (m?.excerpts && Array.isArray(m.excerpts)) {
      excerptsText = m.excerpts
        .map((excerpt: any) => excerpt?.excerpt || '')
        .filter((text: string) => text.trim() !== '')
        .join(' ');
    }

    return {
      id: m._id,
      title: m?.title,
      text: m?.text,
      title1: m?.textItem?.title,
      text1: m?.textItem?.text,
      excerpts: excerptsText, // Add excerpts as a searchable field
    };
  });
  miniSearch.addAll(aligned);

  const searchTextItems = () => {
    if (query === "") {
      setTextItemsResults([]);
      return;
    }
    setLoadingtextItems(true)
    searchEvidences(query, auth0)
      .then((res) => {
        setLoadingtextItems(false)
        setTextItemsResults(res);
      })
      .catch((e) => console.log(e));
  };

  const searchEvidence = (text: string) => {
    setQuery(text);

    if (text === "") {
      setActiveSearch(false);
      setTextItemsResults([]);
    } else {
      const results: any[] = miniSearch.search(text);

      const resIds = results.map((m: any) => m.id);
      const matchedRequests = allRequests.filter((m: any) => {
        return resIds.includes(m._id);
      });

      // Sort results by field priority
      const sortedRequests = matchedRequests.sort((a, b) => {
        const aScore = getFieldMatchScore(a, text);
        const bScore = getFieldMatchScore(b, text);
        return bScore - aScore; // Higher scores first
      });

      setActiveSearch(true);
      setSearchedEvidence(sortedRequests);
      setTriggerSearch(!triggerSearch);
    }
  };

  // Helper function to score matches based on which fields contain the search text
  const getFieldMatchScore = (item: any, searchText: string) => {
    const lowerSearchText = searchText.toLowerCase();
    let score = 0;
    
    // Check each field and assign priority scores
    if (item?.title?.toLowerCase().includes(lowerSearchText)) score += 100;
    if (item?.textItem?.title?.toLowerCase().includes(lowerSearchText)) score += 80;
    if (item?.text?.toLowerCase().includes(lowerSearchText)) score += 60;
    if (item?.textItem?.text?.toLowerCase().includes(lowerSearchText)) score += 40;
    
    // Check excerpts
    if (item?.excerpts && Array.isArray(item.excerpts)) {
      const excerptsText = item.excerpts
        .map((excerpt: any) => excerpt?.excerpt || '')
        .join(' ')
        .toLowerCase();
      if (excerptsText.includes(lowerSearchText)) score += 20;
    }
    
    return score;
  };

  const chooseMatch = (id: string, isFromSearch: boolean) => {
    /* console.log(id); */
    setAddEvidenceFormScreen(false);
    setCardView(true);

    let found = {};

    if (isFromSearch) {
      found = textItemsResults?.find((m: any) => m._id === id) || {};
      found = { ...found, status: "search" };
    } else {
      found =
        allRequestsContext?.find((m: any) => m._id === id) ||
        matches?.find((m: any) => m._id === id) ||
        requestsMatches?.find((m: any) => m._id === id) ||
        {};
    }

    setChosenEvidence(found);
    setIndex(id);
  };

  useEffect(() => {
    if (allRequests.length > 0 && requestId && requestId !== "" && chosenEvidence == null) {
      chooseMatch(requestId, false);
    }
  }, [allRequests]);
  useEffect(() => {
    if (idea?._id) {
      setIsLoading(true);
      getIdeaActivityLogs(idea?._id, auth0)
        .then((response) => {
          const logs = response.activityLogs || [];
          setActivityLogs(logs);
        })
        .catch((error) => {
          console.error('Failed to fetch activity logs:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [ideaHistoryView]);
  
  const updateData = () => {
    if (allRequestsContext.length > 0 && requestId && requestId !== "") {
      chooseMatch(requestId, false);
    }
  
    const filteredRequests = filterRequests(allRequestsContext, activeFilters, ideasFiltersConfig);
    const filteredMatches = filterRequests(matches, activeFilters, ideasFiltersConfig);
    const filteredStrongMatches = filterRequests(strongMatches, activeFilters, ideasFiltersConfig);
    const filteredRequestsMatches = filterRequests(requestsMatches, activeFilters, ideasFiltersConfig);
    const filteredStrongRequestsMatches = filterRequests(strongRequestsMatches, activeFilters, ideasFiltersConfig);

    setDisplayedRequests(sortRequests(filteredRequests, activeSort));
    setDisplayedMatches(sortRequests(filteredMatches, activeSort));
    setDisplayedStrongMatches(sortRequests(filteredStrongMatches, activeSort))
    setDisplayedRequestsMatches(sortRequests(filteredRequestsMatches, activeSort));
    setDisplayedStrongRequestsMatches(sortRequests(filteredStrongRequestsMatches, activeSort))

    const noTrendFilters = activeFilters.filter(
      (filter) => filter.name !== "quarter" && filter.name !== "week"
    );
  
    const filteredRequestsTrend = filterRequests(allRequestsContext, noTrendFilters, ideasFiltersConfig);
    const filteredStrongMatchesTrend = filterRequests(strongMatches, noTrendFilters, ideasFiltersConfig);
    const filteredStrongRequestsMatchesTrend = filterRequests(strongRequestsMatches, noTrendFilters, ideasFiltersConfig);
  
    setRequestsTrend(filteredRequestsTrend);
    setMatchesTrend(filteredStrongMatchesTrend);
    setRequestsMatchesTrend(filteredStrongRequestsMatchesTrend);
  
  };

  useEffect(() => {
    updateData();
  }, [activeFilters, ideaId, type, allRequestsContext, strongMatches, strongRequestsMatches, matches, requestsMatches, activeSort]);


  useEffect(() => {
    if (activeSort) {
      setDisplayedRequests(prev => sortRequests(prev, activeSort));
      setDisplayedMatches(prev => sortRequests(prev, activeSort));
      setDisplayedRequestsMatches(prev => sortRequests(prev, activeSort));
      setDisplayedStrongMatches(prev => sortRequests(prev, activeSort));
      setDisplayedStrongRequestsMatches(prev => sortRequests(prev, activeSort));
    }
  }, [activeSort, ideaId]);

  const throttledSearch = useThrottle(() => searchTextItems(), 1000);

  const updateIdeaDescription = (text: string) => {
    if (idea && idea?.description !== text) {
      const ideaObj = {
        id: idea._id,
        description: text,
      };
      saveIdea(ideaObj, auth0)
        .then(() => {
          
          setMatchesTrigger(0)
          setIdea({...idea, description})
        })
        .catch((e: any) => console.log(e));
    }
  };

  const longDescriptionCheck = () => {
    if (descWidth > 600) {
      setIsLongDescription(true);
    } else {
      setIsLongDescription(false);
    }
  };

  const longTitleCheck = () => {
    if (titleWidth > 520) {
      setIsLongTitle(true);
    } else {
      setIsLongTitle(false);
    }
  };

  const navToPerspective = () => {
    setCardView(false);
    setAddEvidenceFormScreen(false);
    setChosenEvidence(null)
  };

  useEffect(() => {
    query !== "" && throttledSearch();
  }, [triggerSearch]);

  useEffect(() => {
    setDescription(stripHtml(idea?.description || "") || "");
    setTitle(idea?.title);
    longDescriptionCheck();
    longTitleCheck();
  }, [idea, ideaId]);

  useEffect(() => {
    if(ideaId) {
      getDuplicateIdea(ideaId, auth0)
        .then((response) => {
          setDuplicateIdea(response);
        })
        .catch((error) => {
          // 404 is expected when no duplicate exists - just set to null
          if (error?.response?.status === 404) {
            setDuplicateIdea(null);
          } else {
            console.error('Failed to fetch duplicate idea:', error);
          }
        });     
    } else {
      setDuplicateIdea(null);
    }
  }, [ideaId, duplicateIdeaModalOpened]);

  return (
    <Box 
      mah='100%'
      h={`100vh`}
      sx={{
        borderBottom: "1px solid #D8D8DB",
        overflowY: 'hidden',
        maxHeight: '100vh'
      }}>
      <Flex
        mah='100%'
        h={reviewMode ? "74px" : "74px"}
        px="16px"
        bg="#F8F8FB"
        sx={{
          borderBottom: "1px solid #D8D8DB",
          overflowY: 'hidden',
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Header
          reviewMode={reviewMode}
          setReviewMode={setReviewMode}
          description={description}
          title={title}
          setTitle={setTitle}
          isLongTitle={isLongTitle}
          longTitleCheck={longTitleCheck}
          descWidth={descWidth}
          titleWidth={titleWidth}
          isLongDescription={isLongDescription}
          duplicateIdea={duplicateIdea}
          setDuplicateIdea={setDuplicateIdea}
          duplicateIdeaModalOpened={duplicateIdeaModalOpened}
          setDuplicateIdeaModalOpened={setDuplicateIdeaModalOpened}
        />
      </Flex>
      <Split
        sizes={[65, 35]} 
        minSize={[650, 496]} 
        expandToMin={false}
        gutterSize={2} 
        snapOffset={30}
        dragInterval={1}
        direction="horizontal" 
        style={{ display: "flex"}}
      >
        <Box
          bg="#F8F8FB"
          style={{
            borderRight: '1px solid #D8D8DB',
            borderBottom: '1px solid #D8D8DB',
            overflowY: 'hidden',
            height: `calc(100vh - 137px)`,
          }}
        >
          {reviewMode && (
            <OverView
              reviewMode={reviewMode}
              setReviewMode={setReviewMode}
              description={description}
              setDescription={setDescription}
              updateIdeaDescription={updateIdeaDescription}
              longDescriptionCheck={longDescriptionCheck}
              idea={idea}
            />
          )}
          <Body
            chooseMatch={chooseMatch}
            addEvidenceFormScreen={addEvidenceFormScreen}
            setAddEvidenceFormScreen={setAddEvidenceFormScreen}
            setCardView={setCardView}
            activeSortOrFilter={activeSortOrFilter}
            displayedRequests={displayedRequests}
            activeSearch={activeSearch}
            searchEvidence={searchEvidence}
            searchedEvidence={searchedEvidence}
            query={query}
            textItemsResults={textItemsResults}
            loadingtextItems={loadingtextItems}
            sortDescending={isDescendingSort}
            chosenEvidence={chosenEvidence}
            reviewMode={reviewMode}
            navToPerspective={navToPerspective}
            setActiveSearch={setActiveSearch}
            allRequests={allRequests}
            displayedMatches={displayedMatches}
          />
        </Box>
        <Box bg="#FDFEFF">
          {cardView ? (
            <SideBar
              reviewMode={reviewMode}
              navToPerspective={navToPerspective}
              setActiveSearch={setActiveSearch}
              componentType="idea"
            />
          ) : addEvidenceFormScreen ? (
            <AddEvidenceScreen
              addEvidenceFormScreen={addEvidenceFormScreen}
              setAddEvidenceFormScreen={setAddEvidenceFormScreen}
              navToPerspective={navToPerspective}
              reviewMode={reviewMode}
            />
          ) : loadingEvidence ? (
            <Box w="496px"></Box>
          ) : ideaHistoryView ? (
            <IdeaHistoryView activityLogs={activityLogs} idea={idea} setIdeaHistoryView={setIdeaHistoryView} />
          ) :  !loadingEvidence && allRequests.length === 0 ? (
            <Flex justify="center" p={30} w="496px">
              <Stack
                px={50}
                py={25}
                mt={36}
                w="360px"
                h="295px"
                bg="rgba(92, 92, 235, 0.1)"
                sx={{ borderRadius: "8px" }}
              >
                <Box>
                  <Text fz={13} fw={600}>
                    There are no Evidences for this Idea yet.
                  </Text>
                  <Text fz={13}>
                    You can enrich the Idea with Evidences in 3 ways:
                  </Text>
                </Box>

                <Text fz={13}>
                  • Edit the Idea's description to find matching evidences
                  suggested by AI
                </Text>
                <Text fz={13}>
                  • Search for existing evidences based on keyword
                </Text>
                <Text
                  fz={13}
                  color="#5C5CEB"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    setAddEvidenceFormScreen(true)
                    posthog.capture('add_evidence_clicked', {
                      ideaId: idea._id,
                      type: 'manually'
                    })
                  }}
                >
                  • Add Evidences manually
                </Text>
              </Stack>
            </Flex>
          ) : (
            <Box
              sx={{
                height: 'calc(100vh - 137px)',
                maxHeight: 'calc(100vh - 137px)',
                overflow: 'scroll',
                scrollbarWidth: 'none',
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ width: '92%' }}>
                  <Impact ideaPage />
                  <Box
                    sx={{
                      marginLeft: 18,
                      marginRight: -42,
                      maxWidth: '100%',
                      width: '100%',
                    }}
                  >
                    <TrendGraph />
                  </Box>
                  <EnhancedBusinessSources ideaPage />
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Split>
      {/* Elements for size measurement */}

      <Flex
        p="0px"
        m="0px"
        mah="0px"
        h="0px"
        ref={ref2}
        sx={{
          transform: "scale(0)",
          position: "absolute",
          zIndex: 2,
        }}
      >
        <DescriptionWidthMeasurment description={description} longDescriptionCheck={longDescriptionCheck}/>
      </Flex>
      <Flex
        p="0px"
        m="0px"
        mah="0px"
        h="0px"
        ref={ref1}
        sx={{
          transform: "scale(0)",
          position: "absolute",
          zIndex: 1,
        }}
      >
        <TitleWidthMeasurment title={title} longTitleCheck={longTitleCheck}/>
      </Flex>
    </Box>
  );
};

export default NewIdeaView;
